export default (component, scope) => {
  let tr = component.$i18n.messages[component.$i18n.locale]
  scope.split('.').forEach(x => { tr = tr[x] })
  return Object.keys(tr)
    .map(e => ({
      code: e.toString(),
      name: component.$t([scope, e].join('.'))
    }))
}



// WEBPACK FOOTER //
// ./src/components/inputs/collection.js